import React, { useRef } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Label, InputGroup } from "reactstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import CustomReactSelect from "../../components/CustomReactSelect";
import ButtonLoader from "../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../ticketModule/variables/ListingVariables";

const customStyles = {
	control: (provided) => ({ ...provided, border: "none" }),
};

const ExtractEmpDetails = (props) => {
	const { options, startDate, endDate, status, selectedStatus } = props;
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<Container fluid className="pl-0 pr-0">
			<Form>
				<Label className="select-criteria-form-title">
					Extract checkin checkout details of employees
				</Label>
				<Row className="emp-detail-row1">
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center justify-content-between mb-1">
							<Form.Label className="mb-0">
								Select Employee
							</Form.Label>
							<CustomReactSelect
								name="employeeId"
								placeholder="Select Employee"
								className="dropDown"
								options={options}
								value={props.selectedEmployee}
								onChange={(obj) => props.getEmpID(obj)}
								styles={customStyles}
								isSearchable={false}
							/>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center  justify-content-between mb-1">
							<Form.Label className="mb-0">Status</Form.Label>
							<CustomReactSelect
								name="status"
								className="dropDown"
								placeholder="Select"
								options={status}
								value={selectedStatus}
								onChange={(obj) => props.getEmpstatus(obj)}
								styles={customStyles}
								isSearchable={false}
							/>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center  justify-content-between mb-1">
							<Form.Label className="mb-0">
								Work Station
							</Form.Label>
							<CustomReactSelect
								name="status"
								className="dropDown"
								placeholder="Select"
								options={props.workStationList}
								value={props.selectedWorkStation}
								onChange={(obj) =>
									props.handleWorkStationChange(obj)
								}
								styles={customStyles}
								isSearchable={false}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="emp-detail-row2">
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center  justify-content-between mb-1">
							<Form.Label className="mb-0">Start Date</Form.Label>
							<InputGroup className="startDate-datepicker-wrapper datepicker-input">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									name="startDate"
									className="custom-box"
									onChange={props.startDateHandleChange}
									value={startDate}
									selected={startDate}
									dateFormat="dd/MM/yyyy"
									autoComplete="off"
									maxDate={new Date()}
									ref={startDatepickerRef}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
									onClick={() => openStartDatepicker()}
								/>
							</InputGroup>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center  justify-content-between mb-1">
							<Form.Label className="mb-0">End Date</Form.Label>
							<InputGroup className="startDate-datepicker-wrapper datepicker-input">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									name="endDate"
									className="custom-box"
									value={endDate}
									onChange={props.endDateHandleChange}
									selected={endDate}
									minDate={startDate}
									onChangeRaw={(e) => {
										e.preventDefault();
									}}
									dateFormat="dd/MM/yyyy"
									autoComplete="off"
									maxDate={new Date()}
									ref={endDatepickerRef}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
									onClick={() => openEndDatepicker()}
								/>
							</InputGroup>
						</Form.Group>
					</Col>
				</Row>
			</Form>
			<Row className="extractDetail-form-btns">
				<Col className="align-items-center d-flex btns-col p-0">
					<input
						type="submit"
						value="Submit"
						className="submit-btn leftBtn"
						onClick={props.getExtractCheckInCheckOutRecord}
					/>
					<ButtonLoader
						className={ExcelBtnClassName}
						disabled={
							!props.employeeRecord.length || props.showBtnLoading
						}
						onClick={props.exportToExcel}
						btnTitle={ExcelBtnTitle}
						showBtnLoading={props.showBtnLoading}
					/>
				</Col>
			</Row>
			<div className="clear"></div>
		</Container>
	);
};

export default ExtractEmpDetails;
